export default __webpack_public_path__ + "f047a536aee9dd87809204d41249ce0b.png";